import { useMemo } from 'react'
import { FlightsClassTypes } from 'constants/flight'
import { MALDIVES_BUNDLE_DEFAULT_GUESTS } from 'constants/charterFlight'
import { MALDIVES_CHARTER_ROUTE } from 'api/lib/flightDealMap'
import { sumUpOccupancies } from 'lib/offer/occupancyUtils'
import { useCheapestBundlePrice } from './MaldivesDirectSearchPage/hooks/useCheapestBundlePrice'
import { getMaldivesBannerPriceDisplay } from './getMaldivesBannerPriceDisplay'

interface UseMaldivesBannerPriceParams {
  enabled: boolean
  nights: number
  rooms: Array<App.Occupants>
  useMemberPrice: boolean
  checkIn?: string
  priceMode?: 'total' | 'perPerson'
  /**
   * Opt into streamed search `lowestPrice` for anytime (no checkIn) banners.
   * Agent Hub flights landing only — Hotel Search / offer-page banners must
   * keep calendar-derived pricing and must not pass this flag.
   */
  useStreamSearchForAnytime?: boolean
}

export function useMaldivesBannerPrice({
  enabled,
  nights,
  rooms,
  useMemberPrice,
  checkIn,
  priceMode,
  useStreamSearchForAnytime = false,
}: UseMaldivesBannerPriceParams) {
  const bannerBundleData = useCheapestBundlePrice({
    checkIn,
    nights,
    rooms,
    fareClass: FlightsClassTypes.ECONOMY,
    charterBundleRoute: MALDIVES_CHARTER_ROUTE,
    useMemberPrice,
    disabled: !enabled,
    useStreamSearchForAnytime,
  })

  return useMemo(() => getMaldivesBannerPriceDisplay({
    enabled,
    bannerBundleData,
    guestCount: sumUpOccupancies(rooms) || MALDIVES_BUNDLE_DEFAULT_GUESTS,
    priceMode,
  }), [enabled, bannerBundleData, rooms, priceMode])
}
